<template>
    <v-container>
        <!-- dialog -->
        <v-dialog
            v-model="dialog"
            width="350"
        >
            <v-card class="rounded-BigLg">
                <v-card-title class="text-h5 pb-0 pt-1 px-2" >
                    <v-btn small icon @click="dialog = false">
                        <v-icon color="grey" small> mdi-close </v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text class="text-center ">
                    <v-icon color="primary" class="my-1"> mdi-logout </v-icon>
                    <h3 class="my-1"> إنهاء رحلة </h3>
                    هل أنت متأكد أنك تريد إنهاء الرحلة ؟
                </v-card-text>

                <v-card-actions class="d-flex justify-center">
                    <div>
                        <v-btn @click="endTripToSchool()" small color="primary" :loading="submitLoading" class="me-2">
                            موافق
                        </v-btn>

                        <v-btn small text @click="dialog = false" :disabled="submitLoading">
                            إلغاء
                        </v-btn>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- dialogMessage -->
        <v-dialog v-model="dialogMessage" width="350">
            <v-card>
                <v-card-title class="d-flex justify-space-between pb-0">
                    <span>
                        الرسائل
                    </span>
                    <v-btn icon :disabled="loading || submitLoading" color="primary" @click="dialogMessage = false">
                        <v-icon> mdi-close </v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text>
                    <v-row class="mt-1 px-2">
                        <v-col cols="12" align-self="center" class="pa-1">
                            <v-autocomplete
                                v-model="studentIds"
                                :items="studentFilterByTripType"
                                :item-text="(item) => item.account.fullName"
                                item-value="studentId"
                                outlined
                                dense
                                label="اسم الطالب"
                                hide-details
                                class="rounded-BigLg"
                                :disabled="loading"
                                multiple
                                clearable
                                autofocus
                            >
                                <template v-slot:prepend-item>
                                    <v-list-item
                                        ripple
                                        @click="toggle"
                                    >
                                        <v-list-item-action>
                                            <v-icon>
                                                {{ iconCities }}
                                            </v-icon>
                                        </v-list-item-action>

                                        <v-list-item-content>
                                            <v-list-item-title>
                                                select all
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-divider class="mt-2"></v-divider>
                                </template>
                                <template v-slot:selection="{ item, index }">
                                    <span v-if="index === 0" class="me-1">{{ item.account.fullName }}</span>
                                    <span
                                        v-if="index === 1"
                                        class="grey--text text-caption"
                                    >
                                        (+{{ studentIds.length - 1 }})
                                    </span>
                                </template>
                            </v-autocomplete>
                        </v-col>

                        <v-col cols="12" align-self="center" class="pa-1">
                            <!-- messages -->
                            <v-autocomplete
                                v-model="message"
                                :items="messages"
                                item-text="message"
                                item-value="id"
                                outlined
                                dense
                                label="الرسالة"
                                hide-details
                                class="rounded-BigLg"
                                height="100"
                                :loading="loading"
                                clearable
                                :disabled="loading"
                            />
                        </v-col>

                        <v-col cols="12" class="py-1">
                            <v-btn
                                color="primary"
                                class="rounded-BigLg"
                                width="100%"
                                :disabled="loading || !studentIds.length || !message"
                                @click="sendMessage()"
                            >
                                إرسال
                                <v-icon size="10" class="mx-1"> mdi-send </v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>

        <template v-if="!showScanner">
            <v-row class="mx-1">
                <v-col cols="6" align-self="center" class="pb-0">
                    <p class="mb-1"> {{ bus.driverName || '-' }} </p>
                </v-col>
                <v-col cols="6" align-self="center" class="pb-0">
                    <p dir="ltr" class="mb-1 text-end primary--text"> {{ moment().format('hh:mm a') || '-' }} </p>
                    <p class="mb-1"> رقم الباص: {{ bus.busNumber || '-' }} </p>
                </v-col>
            </v-row>

            <v-row class="d-flex mt-0 justify-space-around mb-1">
                <v-col cols="5" class=" px-0 me-3 pb-1">
                    <v-btn
                        class="rounded-BigLg"
                        width="100%"
                        color="secondary"
                        @click="
                            isStartTrip === true
                                ? dialog = true
                                : endTrip()"
                    >
                        {{ isStartTrip === true ? 'الوصول إلى المدرسة' : 'إنهاء رحلة' }}
                    </v-btn>
                </v-col>

                <v-col v-if="0" cols="5" class="px-0 me-3 pb-1">
                    <v-btn class="rounded-BigLg" width="100%" color="secondary" @click="showScanner = true">
                        مسح رمز QR
                    </v-btn>
                </v-col>

                <v-col cols="5" class="px-0 me-3 pb-1">
                    <v-btn class="rounded-BigLg" width="100%" color="secondary" @click="dialogMessage = true">
                        إرسال رسالة
                    </v-btn>
                </v-col>
            </v-row>

            <span class="px-4"> الطلاب ({{ studentFilterByTripType?.length || 0 }} {{ studentFilterByTripType?.length > 10 ? 'طالب' : 'طلاب' }}) </span>

            <!-- cards -->
            <v-card elevation="0">
                <v-row  class="scroll-style mt-1 d-flex justify-start">
                    <v-col v-for="(student, index) in studentFilterByTripType" :key="index" cols="12" md="6" class="py-0" align-self="center">
                        <!-- cards -->
                        <v-card
                            elevation="2"
                            class="rounded-BigLg px-1 mx-2 d-flex justify-center align-center my-2"
                            style="height: 60px"
                            :class="{
                                'border-red': student.status === studentBusStatusType.absent,
                                'border-green': student.status === studentBusStatusType.onBus
                            }"
                        >
                            <v-row class="px-2" >
                                <v-col cols="3" class="py-1 px-1 h-100" align-self="center">
                                    <span class="fs-sm"> {{ student.account.fullName || '-' }} </span>
                                </v-col>

                                <v-divider vertical class="my-4 px-1" />

                                <v-col class="py-1 px-1 h-100" cols="3" align-self="center">
                                    <div class="fs-sm">
                                        <span class="primary--text"> {{ isStartTrip === true ? 'وقت الوصول' : 'وقت العودة' }}   </span>
                                        <br />
                                        <span dir="ltr"> {{ isStartTrip === true ? moment(student.expectedArrival).format('hh:mm a') :  moment(student.expectedReturn).format('hh:mm a') }} </span>
                                    </div>
                                </v-col>
                                <v-col class="py-1 px-1 h-100" cols="3" align-self="center">
                                    <div class="fs-sm">
                                        <span class="primary--text"> رقم الموبايل </span>
                                        <div class="d-flex flex-column">
                                            {{
                                                getContact(student, 'جوال الأب') || '-'
                                            }}
                                            <br />
                                            {{
                                                getContact(student, 'جوال الأم') || '-'
                                            }}
                                        </div>
                                    </div>
                                </v-col>
                                <v-spacer />

                                <v-col v-if="isStartTrip === true" cols="2" class="d-flex justify-end px-0">
                                    <v-btn
                                        v-if="!student.status || student.status === studentBusStatusType.atSchool"
                                        class="rounded-btn-card"
                                        width="100%"
                                        height="56"
                                        color="primary"
                                        @click="sheet = true; studentInfo = student"
                                    >
                                        الحالة
                                    </v-btn>
                                    <v-btn
                                        v-else-if="student.status === studentBusStatusType.onBus"
                                        class="rounded-btn-card"
                                        width="100%"
                                        height="59"
                                        color="green white--text"
                                        readonly
                                    >
                                        موجود
                                    </v-btn>
                                    <v-btn
                                        v-else
                                        class="rounded-btn-card"
                                        width="100%"
                                        height="59"
                                        color="red white--text"
                                        @click="sheet = true; studentInfo = student"
                                    >
                                        غائب
                                    </v-btn>
                                </v-col>

                                <v-col v-else cols="2" class="d-flex justify-end px-0">
                                    <v-btn
                                        v-if="student.status === studentBusStatusType.home"
                                        class="rounded-btn-card"
                                        width="100%"
                                        height="56"
                                        color="success"
                                        readonly
                                    >
                                        في المنزل
                                    </v-btn>
                                    <v-btn
                                        v-else-if="student.status === studentBusStatusType.absent"
                                        class="rounded-btn-card"
                                        width="100%"
                                        height="59"
                                        color="red white--text"
                                        readonly
                                    >
                                        غائب
                                    </v-btn>
                                    <v-btn
                                        v-else
                                        class="rounded-btn-card"
                                        width="100%"
                                        height="59"
                                        color="primary"
                                        @click="sheet = true; studentInfo = student"
                                    >
                                        في <br /> الباص
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-col>
                </v-row>
            </v-card>

            <v-bottom-sheet
                v-model="sheet"
            >
                <v-sheet
                    class="text-center"
                    height="230px"
                >
                    <v-row class="px-5">
                        <v-col cols="8">
                            <h3 class="text-start">
                                {{ studentInfo.account?.fullName || '-' }}
                            </h3>
                            <div class="text-start">
                                <v-icon color="primary"> mdi-map-marker </v-icon>
                                <span> {{ studentInfo.account?.address || studentInfo.account?.area || studentInfo.account?.city?.name || '-' }} </span>
                            </div>
                        </v-col>

                        <v-col cols="4" class="d-flex flex-column px-1">
                            <v-btn color="success" class="rounded-xl" width="100%" @click="call(getContact(studentInfo, 'جوال الأب'))">
                                <v-icon class="pe-2"> mdi-phone </v-icon>
                                اتصال بالأب
                            </v-btn>

                            <v-btn color="success" class="rounded-xl mt-2" @click="call(getContact(studentInfo, 'جوال الأم'))">
                                <v-icon class="pe-2"> mdi-phone </v-icon>
                                اتصال بالأم
                            </v-btn>
                        </v-col>

                        <v-col v-if="isStartTrip === true" cols="12">
                            <div>
                                <v-btn
                                    width="48%"
                                    class="rounded-BigLg me-1"
                                    color="success white--text"
                                    @click="markAttendance(studentInfo, studentBusStatusType.onBus)"
                                    :loading="submitLoading && pendingStatus === studentBusStatusType.onBus"
                                    :disabled="(submitLoading && pendingStatus !== studentBusStatusType.onBus) || nearHomeLoading"
                                >
                                    تسجيل حضور
                                </v-btn>
                                <v-btn
                                    width="48%"
                                    class="rounded-BigLg ms-1"
                                    color="red white--text"
                                    @click="markAttendance(studentInfo, studentBusStatusType.absent)"
                                    :loading="submitLoading && pendingStatus === studentBusStatusType.absent"
                                    :disabled="(submitLoading && pendingStatus !== studentBusStatusType.absent) || nearHomeLoading"
                                >
                                    تسجيل غياب
                                </v-btn>
                            </div>
                        </v-col>
                        <v-col v-else cols="12">
                            <v-btn
                                v-if="studentInfo.status !== studentBusStatusType.home"
                                width="100%"
                                class="rounded-BigLg me-1"
                                color="success white--text"
                                @click="dropoffStudent(studentInfo)"
                                :disabled="nearHomeLoading"
                                :loading="submitLoading"
                            > وصول إلى المنزل </v-btn>
                        </v-col>
                        <v-col cols="12" class="">
                            <v-btn
                                color="secondary"
                                width="100%"
                                :loading="nearHomeLoading"
                                class="rounded-BigLg"
                                @click="notifyApproaching(studentInfo)"
                            >
                                قريب جداً!
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-sheet>
            </v-bottom-sheet>
        </template>
        <!-- Scanner view -->
        <!-- <div v-if="showScanner" class="scanner-container">
            <v-btn
                class="close-scanner-btn"
                icon
                @click="closeScanner"
            >
                <v-icon color="white">mdi-close</v-icon>
            </v-btn>
            <StreamBarcodeReader
                @decode="onDecode"
                @loaded="onLoaded"
            ></StreamBarcodeReader>
            <div class="scanner-overlay">
                <div class="scanner-line"></div>
            </div>
        </div> -->
    </v-container>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'
import { studentBusStatusType } from '@/helper/enums'
// import { StreamBarcodeReader } from 'vue-barcode-reader'
export default {
    components: {
        // StreamBarcodeReader
        // ImageBarcodeReader
    },

    data () {
        return {
			sheet: false,
			studentInfo: {},
            dialog: false,
            isStart: true,
            submitLoading: false,
            pendingStatus: null,
            decodedText: '',
            showScanner: false,
            isExist: true,
            tripStudents: [],
            nearHomeLoading: false,
            permission: null,
            dialogMessage: false,
            studentIds: [],
            message: null,
            loading: false,
            studentBusStatusType,
            latitude: null,
            longitude: null
        }
    },

    watch: {
        dialogMessage (val) {
            if (!val) {
                this.studentIds = []
                this.message = null
            }
        }
    },

    computed: {
        ...mapState({
            info: state => state.auth.info,
            bus: state => state.auth.bus,
            messages: state => state.messages.messages,
            tripId: state => state.transport.tripId
        }),

        isStartTrip () {
            return JSON.parse(this.$route.query.isStart)
        },

        studentFilterByTripType () {
            return this.tripStudents
        },

        selectedAll () {
            return this.studentIds.length === this.studentFilterByTripType.length
        },
        iconCities () {
            if (this.selectedAll) return 'mdi-close-box'
            return 'mdi-checkbox-blank-outline'
        }
    },

    methods: {
        moment,

        fetchRoster () {
            if (!this.tripId) return Promise.resolve()
            return this.$store.dispatch('transport/fetchTrip', { tripId: this.tripId }).then((data) => {
                this.tripStudents = data.students || []
            })
        },

        getContact (student, label) {
            const entry = (student.contactInfo || []).find(c => c.name === label)
            return entry?.value || null
        },

        markAttendance (studentInfo, status) {
            this.submitLoading = true
            this.pendingStatus = status
            this.$store.dispatch('transport/markAttendance', {
                tripId: this.tripId,
                studentId: studentInfo.studentId,
                status
            }).then(() => {
                return this.fetchRoster()
            }).then(() => {
                this.sheet = false
                this.$eventBus.$emit('تم تسجيل الحالة بنجاح')
            }).catch(() => {
                this.$eventBus.$emit('حدث خطأ ما، يرجى المحاولة مرة أخرى')
            }).finally(() => {
                this.submitLoading = false
                this.pendingStatus = null
            })
        },

        call (number) {
            if (number) {
                window.location.href = `tel:${number}`
            }
        },

        // onDecode (result) {
        //     if (result) {
        //         const student = this.info.students.find(s => s.AccountId === result)
        //         if (student) {
        //             this.studentInfo = student
        //             this.sheet = true
        //             this.closeScanner()
        //             this.$eventBus.$emit('تم العثور على الطالب')
        //         } else {
        //             this.$eventBus.$emit('الطالب غير موجود في هذه الرحلة')
        //         }
        //     }
        // },

        // onLoaded () {
        //     console.log('Barcode reader loaded')
        // },

		// closeScanner () {
		// 	this.showScanner = false
		// },

		// openScanner () {
		// 	this.showScanner = true
		// },

        endTripToSchool () {
            this.submitLoading = true
            this.$store.dispatch('transport/notifySchoolArrival', { tripId: this.tripId })
                .then(() => this.$store.dispatch('transport/endActiveTrip', { tripId: this.tripId }))
                .then(() => {
                    this.$eventBus.$emit('تم إنهاء الرحلة بنجاح')
                    this.dialog = false
                    this.$router.replace({ name: 'choose-page' })
                }).catch(() => {
                    this.$eventBus.$emit('حدث خطأ ما، يرجى المحاولة مرة أخرى')
                }).finally(() => {
                    this.submitLoading = false
                })
        },

        dropoffStudent (studentInfo) {
            this.submitLoading = true
            this.$store.dispatch('transport/dropoffStudent', {
                tripId: this.tripId,
                studentId: studentInfo.studentId
            }).then(() => this.fetchRoster()).then(() => {
                this.sheet = false
                this.$eventBus.$emit('تم إنهاء رحلة العودة بنجاح')
            }).catch(() => {
                this.$eventBus.$emit('حدث خطأ ما، يرجى المحاولة مرة أخرى')
            }).finally(() => {
                this.submitLoading = false
            })
        },

        notifyApproaching (studentInfo) {
            this.nearHomeLoading = true
            this.$store.dispatch('transport/notifyApproaching', {
                tripId: this.tripId,
                studentId: studentInfo.studentId
            }).then(() => {
                this.sheet = false
            }).finally(() => {
                this.nearHomeLoading = false
            })
        },
        sendNotification () {
            const notification = new Notification('عنوان الإشعار', {
                body: 'هذا هو محتوى الإشعار!',
                icon: 'https://example.com/icon.png' // يمكنك وضع رابط أي أيقونة هنا
            })

            notification.onclick = () => {
                window.focus()
            }
        },

        sendMessage () {
            this.loading = true
            this.$store.dispatch('messages/sendMessage', {
                tripId: this.tripId,
                studentIds: this.studentIds,
                messageTemplateId: this.message
            }).then(() => {
                this.studentIds = []
                this.message = null
                this.$eventBus.$emit('show-snackbar', 'تم إرسال الرسالة بنجاح')
                this.dialogMessage = false
            }).catch(() => {
                this.$eventBus.$emit('show-snackbar', 'فشل إرسال الرسالة')
            }).finally(() => {
                this.loading = false
            })
        },

        toggle () {
            this.$nextTick(() => {
                if (this.selectedAll) {
                    this.studentIds = []
                } else {
                    this.setStudent()
                }
            })
        },

        setStudent () {
            this.studentIds = []
            if (!this.studentFilterByTripType) return
            this.studentFilterByTripType.forEach(student => {
                this.studentIds.push(student.studentId)
            })
        },

        endTrip () {
            this.submitLoading = true
            this.$store.dispatch('transport/endActiveTrip', { tripId: this.tripId }).then(() => {
                this.$router.replace({ name: 'choose-page' })
            }).catch(() => {
                this.$eventBus.$emit('حدث خطأ ما، يرجى المحاولة مرة أخرى')
            }).finally(() => {
                this.submitLoading = false
            })
        },

        getLocation () {
            if (!navigator.geolocation) return
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    this.latitude = position.coords.latitude
                    this.longitude = position.coords.longitude

                    this.$store.dispatch('transport/sendCoordinates', {
                        tripId: this.tripId,
                        lat: this.latitude,
                        lng: this.longitude
                    })
                },
                (error) => {
                    console.error('خطأ في الحصول على الموقع:', error)
                }
            )
        },

        startInterval () {
            this.interval = setInterval(() => {
                this.getLocation()
            }, 30000)
        }
    },

    created () {
        if (!this.messages.length) {
            this.loading = true
            this.$store.dispatch('messages/fetchAll').finally(() => {
                this.loading = false
            })
        }

        if (!this.tripId) {
            this.$router.replace({ name: 'choose-page' })
            return
        }
        this.fetchRoster()

        this.permission = Notification.permission
    },

    mounted () {
        if (this.tripId) {
            this.startInterval()
        }
    },

    beforeDestroy () {
        clearInterval(this.interval)
    }
}
</script>

<style>
.rounded-btn-card {
    border-top-left-radius: 12px;
    border-bottom-left-radius: 12px;
}

.border-red {
    border: 2px solid red !important;
    border-radius: 12px;
}
.border-green {
    border: 2px solid green !important;
    border-radius: 12px;
}
/* .scroll-style {
    float:left;
    overflow-y: auto;
    height: 800px;
} */
/* .scanner-container {
    width: 100%;
    height: 100vh;
    scroll-behavior: auto;
    direction: ltr;
} */
/*
.scanner-container div {
    width: 100%;
    height: 100vh;
    direction: ltr;
    width: 100%;
} */
/* .scanner-container >>> video {
    width: 100%;
    height: 100%;
    direction: ltr;
    width: 100%;
} */

</style>
